import { render, staticRenderFns } from "./ActionsGroup.vue?vue&type=template&id=b9568d54"
import script from "./ActionsGroup.vue?vue&type=script&lang=js"
export * from "./ActionsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports